import { COLORS } from '@btime/constants'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { HorizontalLine } from '../../../../../../../components/shapes/Line'
import { canRenderInputForType } from '../_helpers/hideInputForType'
import { useChecklistFormActions, useSelectedQuestion } from '../../../../_form/ChecklistFormHandler'
import CheckboxInput from '../../../../../../../components/form/CheckboxInput'
import FormItem from '../../../../../../../components/form/FormItem'
import Input from '../../../../../../../components/form/Input'
import { Title } from '../../../../../../../components/presentation/Text'
import Separator from '../../../../../../../packages/kiti/components/helpers/Separator'
import useHandleGroupedConfigChange from '../_helpers/useHandleGroupConfigChange'

const PhotoSection = () => {
  const { t } = useTranslation('editChecklist')
  const { handleSelectedQuestionChange } = useChecklistFormActions()
  const selectedQuestion = useSelectedQuestion()

  const handleGroupedConfigChange = useHandleGroupedConfigChange()
  const shouldRender = canRenderInputForType(selectedQuestion.questionType.name)
  const shouldRenderGallery = shouldRender('gallery')
  const shouldRenderPhoto = shouldRender('photos')

  if (!shouldRenderPhoto && !shouldRenderGallery) return false

  return (
    <>
      <Separator weight={6} />
      <Title size="h6" color={COLORS.dark4}>
        {t('photoSettings')}
      </Title>
      <HorizontalLine thin lineColor={COLORS.light2} />
      <Separator weight={2} />

      {shouldRenderGallery && (
        <FormItem label={t('minQuantity')}>
          <Input
            small
            type="number"
            value={selectedQuestion.minPhotos}
            onChange={handleSelectedQuestionChange('minPhotos')}
          />
        </FormItem>
      )}

      {shouldRenderPhoto && (
        <div>
          <CheckboxInput
            label={t('allowPhotos')}
            value={selectedQuestion.photosEnabled}
            onChange={handleGroupedConfigChange('photosEnabled')}
          />

          <CheckboxInput
            label={t('requiredPhotos')}
            value={selectedQuestion.photosRequired}
            onChange={handleSelectedQuestionChange('photosRequired')}
            disabled={!selectedQuestion.photosEnabled}
          />
        </div>
      )}

      {shouldRenderGallery && (
        <div>
          <Separator weight={2} />
          <HorizontalLine thin lineColor={COLORS.light2} />
          <Separator weight={2} />
        </div>
      )}

      {(shouldRenderPhoto || shouldRenderGallery) && (
        <CheckboxInput
          label={t('allowGalleryPhotos')}
          value={selectedQuestion.photosFromGallery}
          onChange={handleSelectedQuestionChange('photosFromGallery')}
          disabled={!shouldRenderGallery && !selectedQuestion.photosEnabled}
        />
      )}
    </>
  )
}

export default PhotoSection
